import React, { useState } from "react";
import { server } from "../common";
import { toast } from "react-toastify";

const AgniveerRegistrationForm = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    gender: "",
    age: "",
    height: "",
    weight: "",
    chest: "",
    qualification: "",
    mobile: "",
    address: "",
    district: "",
    state: "",
    pincode: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Age Validation
    const age = parseFloat(formData.age);
    if (age > 23) {
      toast.error("You are not eligible. Age cannot be greater than 23.");
      return;
    }
    if (age < 17.5) {
      toast.error("You are not eligible. Age must be at least 17.5.");
      return;
    }

    setLoading(true);

    const payload = { ...formData };
    if (payload.gender === "Female") {
      payload.chest = "";
    }

    server
      .post("/agniveer/register", payload)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Agniveer Registration Form Submitted Successfully!");
          setFormData({
            fullName: "",
            gender: "",
            age: "",
            height: "",
            weight: "",
            chest: "",
            qualification: "",
            mobile: "",
            address: "",
            district: "",
            state: "",
            pincode: "",
          });
        }
      })
      .catch((err) => {
        console.error("Error submitting form:", err);
        if (err.response && err.response.data && err.response.data.error) {
          toast.error(err.response.data.error);
        } else {
          toast.error("Failed to submit form. Please try again.");
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="container py-3 py-md-5 font-['Poppins',sans-serif]">
      <div className="card shadow-lg border-0 rounded-4 overflow-hidden" style={{ maxWidth: "950px", margin: "0 auto" }}>
        <div className="card-header p-3 p-md-4 text-center text-white" style={{ backgroundColor: "#1d740c" }}>
          <h2 className="fw-bold mb-2 text-uppercase fs-4 fs-md-4 text-black">Agniveer Registration</h2>
          <p className="mb-0 text-black small">
            Fill details carefully as per Agniveer eligibility criteria
          </p>
        </div>

        <div className="card-body p-3 p-md-5">
          <div className="mb-4">
            <h4 className="fw-bold text-success border-bottom border-warning border-3 d-inline-block pb-2" style={{ color: "#1d740c !important" }}>
              Personal Details
            </h4>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="row g-3 g-md-4">
              <div className="col-md-6">
                <label className="form-label fw-bold text-secondary">
                  Full Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  className="form-control form-control-lg bg-light"
                  placeholder="Enter your full name"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-bold text-secondary">
                  Mobile Number (WhatsApp) <span className="text-danger">*</span>
                </label>
                <input
                  type="tel"
                  name="mobile"
                  value={formData.mobile}
                  className="form-control form-control-lg bg-light"
                  placeholder="Enter 10 digit mobile number"
                  pattern="[0-9]{10}"
                  maxLength="10"
                  minLength="10"
                  required
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    setFormData({ ...formData, mobile: val });
                  }}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-bold text-secondary">
                  Gender <span className="text-danger">*</span>
                </label>
                <select
                  name="gender"
                  value={formData.gender}
                  className="form-select form-select-lg bg-light"
                  required
                  onChange={handleChange}
                >
                  <option value="">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label fw-bold text-secondary">
                  Age (17.5 – 23 Years) <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  name="age"
                  value={formData.age}
                  className="form-control form-control-lg bg-light"
                  placeholder="Enter your age"
                  required
                  step="0.1"
                  min="17.5"
                  max="23"
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-bold text-secondary">
                  Height (cm) <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  name="height"
                  value={formData.height}
                  className="form-control form-control-lg bg-light"
                  placeholder="Male: 170cm / Female: 155cm"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-6">
                <label className="form-label fw-bold text-secondary">
                  Weight (kg) <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  name="weight"
                  value={formData.weight}
                  className="form-control form-control-lg bg-light"
                  placeholder="Above 50 kg"
                  required
                  onChange={handleChange}
                />
              </div>

              {formData.gender !== "Female" && (
                <div className="col-md-6">
                  <label className="form-label fw-bold text-secondary">
                    Chest (cm) <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    name="chest"
                    value={formData.chest}
                    className="form-control form-control-lg bg-light"
                    placeholder="Male 80 cm"
                    required
                    onChange={handleChange}
                  />
                </div>
              )}

              <div className="col-12 mt-5">
                <h4 className="fw-bold text-success border-bottom border-warning border-3 d-inline-block pb-2" style={{ color: "#1d740c !important" }}>
                  Contact & Qualification
                </h4>
              </div>

              <div className="col-md-6">
                <label className="form-label fw-bold text-secondary">
                  Qualification <span className="text-danger">*</span>
                </label>
                <select
                  name="qualification"
                  value={formData.qualification}
                  className="form-select form-select-lg bg-light"
                  required
                  onChange={handleChange}
                >
                  <option value="">Select Qualification</option>
                  <option value="10th Pass">10th Pass</option>
                  <option value="12th Pass">12th Pass</option>
                  <option value="Above 12th">Above 12th</option>
                </select>
              </div>



              <div className="col-12">
                <label className="form-label fw-bold text-secondary">
                  Full Address <span className="text-danger">*</span>
                </label>
                <textarea
                  name="address"
                  value={formData.address}
                  className="form-control form-control-lg bg-light"
                  placeholder="Enter your full address with landmark"
                  required
                  rows="3"
                  onChange={handleChange}
                ></textarea>
              </div>

              <div className="col-md-4">
                <label className="form-label fw-bold text-secondary">
                  District <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="district"
                  value={formData.district}
                  className="form-control form-control-lg bg-light"
                  placeholder="Enter your district"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label fw-bold text-secondary">
                  State <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  className="form-control form-control-lg bg-light"
                  placeholder="Enter your state"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-md-4">
                <label className="form-label fw-bold text-secondary">
                  Pin Code <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  name="pincode"
                  value={formData.pincode}
                  className="form-control form-control-lg bg-light"
                  placeholder="Enter 6 digit pin code"
                  pattern="[0-9]{6}"
                  required
                  onChange={handleChange}
                />
              </div>

              <div className="col-12 mt-4">
                <button
                  type="submit"
                  disabled={loading}
                  className="btn btn-success w-100 py-3 fw-bold text-uppercase shadow"
                  style={{ backgroundColor: "#1d740c", fontSize: "1.1rem" }}
                >
                  {loading ? "Submitting..." : "Submit Application"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AgniveerRegistrationForm;
